import React from "react";
import PropTypes from "prop-types";
import { PlainButton } from "@evertrue/et-components";
import classNames from "classnames";

// <a href="#" onClick> is not accessible but our <button> has a ton of CSS on it
const LinkButton = ({ className, style, ...props }) => (
  <PlainButton className={classNames("link-button", className)} style={{ ...style, cursor: "pointer" }} {...props} />
);

LinkButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

LinkButton.defaultProps = {
  children: () => null,
};

export default LinkButton;
